import React from "react";
import { Col, Form, Row, Button } from "react-bootstrap";

import { FsText, FsSelect, FsPhone, FsPassword } from "shared/components/fs";

export default class PersonalInformationForm extends React.PureComponent {
  render() {
    const { props } = this;
    const { formState } = props;
    if (!formState) {
      return null;
    }

    return (
      <Form horizontal>
        <FsText
          formState={formState}
          attribute="email"
          label="E-Mail"
          placeholder="andrea@beispiel.de"
        />

        <FsSelect
          formState={formState}
          attribute="salutation"
          label="Anrede"
          options={["Herr", "Frau"]}
        />

        <FsText
          formState={formState}
          attribute="first_name"
          label="Vorname"
          placeholder="Andrea"
        />

        <FsText
          formState={formState}
          attribute="last_name"
          label="Nachname"
          placeholder="Mustermensch"
        />

        <FsPhone
          formState={formState}
          attribute="phone"
          countryAttribute="phone_country_code"
          label="Telefon"
        />

        <FsPassword
          formState={formState}
          attribute="password"
          label="Passwort"
          help="Mindestens 10 Zeichen"
        />

        <Row>
          <Col sm={1} smOffset={4}>
            <Button
              type="submit"
              className="btn btn-secondary"
              onClick={props.submitFn}
            >
              Weiter
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
